var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-create main-content" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitPaymentData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$t("prepayments.invoice_payment_request"))),
          ]),
          _vm._v(" "),
          _c("ol", { staticClass: "breadcrumb" }, [
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _c(
                  "router-link",
                  {
                    attrs: { slot: "item-title", to: "/funder/dashboard" },
                    slot: "item-title",
                  },
                  [_vm._v(_vm._s(_vm.$t("general.home")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _vm.$route.name === "preapproved.invoice.pending"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/funder/preapproved-invoices",
                        },
                        slot: "item-title",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$tc("preapproved_invoices.invoice", 2))
                        ),
                      ]
                    )
                  : _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/funder/invoices" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$tc("invoices.invoice", 2)))]
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "breadcrumb-item" }, [
              _vm._v(_vm._s(_vm.$t("prepayments.invoice_payment_request"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-actions row" }, [
            _c(
              "div",
              { staticClass: "col-xs-2 mr-4" },
              [
                _vm.isRejectedButtonShow
                  ? _c(
                      "base-button",
                      {
                        attrs: {
                          outline: true,
                          size: "large",
                          icon: "times",
                          color: "theme",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.rejectedPrepaymentRequest()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("general.reject")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-2" },
              [
                _vm.isOfferButtonShow
                  ? _c(
                      "base-button",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          disabled: _vm.isLoading,
                          size: "large",
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("general.offer")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.$route.name === "preapproved.invoice.pending"
          ? _c("SinglePreapprovedInvoiceRow", {
              attrs: { "fetch-data": _vm.fetchData },
            })
          : _c("SingleInvoiceRow", { attrs: { "fetch-data": _vm.fetchData } }),
        _vm._v(" "),
        _c("div", { staticClass: "payment-card card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("prepayments.date"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        "calendar-button": true,
                        disabled: true,
                        "calendar-button-icon": "calendar",
                      },
                      model: {
                        value: _vm.formData.payment_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "payment_date", $$v)
                        },
                        expression: "formData.payment_date",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("general.promised_payment_date"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        "calendar-button": true,
                        disabled: true,
                        "calendar-button-icon": "calendar",
                      },
                      model: {
                        value: _vm.formData.promised_payment_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "promised_payment_date", $$v)
                        },
                        expression: "formData.promised_payment_date",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("prepayments.prepayment_request_number"))
                    ),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.requestNumber) },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("prepayments.offer_requested_on_date"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.supplier_offer_request &&
                      _vm.formData.supplier_offer_request ==
                        "as_soon_as_possible"
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s("As Soon as Possible"),
                            },
                          })
                        : _vm.formData.supplier_offer_request &&
                          _vm.formData.supplier_offer_request == "select_a_date"
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formData.formattedSupplierOfferRequestDate
                              ),
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.loanable_amount"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-input" },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field",
                            attrs: { disabled: "true" },
                            model: {
                              value: _vm.LoanableAmount,
                              callback: function ($$v) {
                                _vm.LoanableAmount = $$v
                              },
                              expression: "LoanableAmount",
                            },
                          },
                          "money",
                          _vm.customerCurrencyMoneyFormat,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.discount"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-input" },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field",
                            attrs: { disabled: "true" },
                            model: {
                              value: _vm.discount,
                              callback: function ($$v) {
                                _vm.discount = $$v
                              },
                              expression: "discount",
                            },
                          },
                          "money",
                          _vm.customerCurrencyMoneyFormat,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  staticClass: "col-sm-6",
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("general.funder_fees"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "base-input" },
                      [
                        _c(
                          "money",
                          _vm._b(
                            {
                              staticClass: "input-field",
                              attrs: { disabled: "true" },
                              model: {
                                value: _vm.funderAmount,
                                callback: function ($$v) {
                                  _vm.funderAmount = $$v
                                },
                                expression: "funderAmount",
                              },
                            },
                            "money",
                            _vm.customerCurrencyMoneyFormat,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.transaction_fees"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-input" },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field",
                            attrs: { disabled: "true" },
                            model: {
                              value: _vm.adminAmount,
                              callback: function ($$v) {
                                _vm.adminAmount = $$v
                              },
                              expression: "adminAmount",
                            },
                          },
                          "money",
                          _vm.customerCurrencyMoneyFormat,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.request_amount"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$utils.formatMoney(
                              _vm.formData.requested_amount,
                              _vm.customerCurrency
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    on: {
                      click: function ($event) {
                        return _vm.offerAmountModel()
                      },
                    },
                  },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("general.offer_amount"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "base-input" },
                      [
                        _c(
                          "money",
                          _vm._b(
                            {
                              staticClass: "input-field",
                              attrs: { disabled: "true" },
                              model: {
                                value: _vm.amount,
                                callback: function ($$v) {
                                  _vm.amount = $$v
                                },
                                expression: "amount",
                              },
                            },
                            "money",
                            _vm.customerCurrencyMoneyFormat,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.$v.formData.amount.$error
                      ? _c("div", [
                          !_vm.$v.formData.amount.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.$t("validation.required"))),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.rate_of_pre_payment"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-input" },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field",
                            class: {
                              invalid:
                                _vm.$v.formData.rate_of_prepayment.$error,
                            },
                            model: {
                              value: _vm.formData.rate_of_prepayment,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "rate_of_prepayment",
                                  $$v
                                )
                              },
                              expression: "formData.rate_of_prepayment",
                            },
                          },
                          "money",
                          _vm.percentageFormatMoneyComponent,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$v.formData.rate_of_prepayment.$error
                    ? _c("div", [
                        !_vm.$v.formData.rate_of_prepayment.between
                          ? _c(
                              "span",
                              {
                                staticClass: "form-group__message text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("validation.enter_valid_tax_rate")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.financing_ratio"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-input" },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field",
                            class: {
                              invalid: _vm.$v.formData.margin_rate.$error,
                            },
                            model: {
                              value: _vm.formData.margin_rate,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "margin_rate", $$v)
                              },
                              expression: "formData.margin_rate",
                            },
                          },
                          "money",
                          _vm.percentageFormatMoneyComponent,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$v.formData.margin_rate.$error
                    ? _c("div", [
                        !_vm.$v.formData.margin_rate.required
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.$t("validation.required"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.formData.margin_rate.between
                          ? _c(
                              "span",
                              {
                                staticClass: "form-group__message text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("validation.enter_valid_tax_rate")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.payment_mode"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.payment_method
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formData.payment_method.name
                              ),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              innerHTML: _vm._s("No Payment Mode Select"),
                            },
                          }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("prepayments.offer_expire"))),
                    ]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        "calendar-button": true,
                        disabled: true,
                        "disabled-dates": {
                          to: new Date(Date.now()),
                        },
                        "calendar-button-icon": "calendar",
                      },
                      model: {
                        value: _vm.formData.offer_expire,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "offer_expire", $$v)
                        },
                        expression: "formData.offer_expire",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.supplier_comment"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.supplier_comment
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formData.supplier_comment),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              innerHTML: _vm._s("No Supplier Comment"),
                            },
                          }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.administrator_comment"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.superAdmin_comment
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formData.superAdmin_comment
                              ),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              innerHTML: _vm._s("No Administrator Comment"),
                            },
                          }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("prepayments.anchor_comment"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-read-box base-read-box-field" },
                    [
                      _vm.formData.anchor_comment
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formData.anchor_comment),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              innerHTML: _vm._s("No Administrator Comment"),
                            },
                          }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group collapse-button-container" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "collapse-button",
                        attrs: {
                          loading: _vm.isLoading,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("prepayments.save_prepayment")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }